import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { TranslateModule } from 'ng2-translate';

import { PipesModule } from '../pipes/pipes.module';
import { DialogComponent } from './dialog/dialog.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
    declarations: [
        DialogComponent,
        HeaderComponent
    ],
    imports: [
        CommonModule,
        ButtonsModule,
        DialogModule,
        PipesModule,
        TranslateModule
    ],
    providers: [],
    exports: [
        DialogComponent,
        HeaderComponent,
        TranslateModule
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts